import { PRIORITY_CONDITION_VALUES } from 'dashboard/helper/automationHelper.js';
export default {
  methods: {
    getDropdownValues(type) {
      switch (type) {
        case 'assign_team':
        case 'send_email_to_team':
          return this.teams;
        case 'assign_agent':
          return this.agents;
        case 'add_label':
        case 'remove_label':
          return this.labels.map(i => {
            return {
              id: i.title,
              name: i.title,
            };
          });
        case 'change_priority':
          return PRIORITY_CONDITION_VALUES;
        case 'whatsapp_template':
          return this.inboxes;
        case 'email_template':
          return this.emailTemplates;
        default:
          return [];
      }
    },
  },
};
